'use strict';
var charAt = require('../internals/string-multibyte').charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/advance-string-index.js
// module id = 192
// module chunks = 3